const MAX_VISIBLE_EVENTS = 7

/**
 * A month day card is a fixed 224px in the design: header, then five 25px tiles and the
 * "View more" link. The week and day grids scroll, so they keep MAX_VISIBLE_EVENTS.
 */
const MAX_VISIBLE_MONTH_EVENTS = 5
const DAYS_IN_WEEK = 7
const UNASSIGNED_ID = "unassigned"

const CALENDAR_TABS = {
  ALL_BOOKINGS: "all-bookings",
  MY_BOOKINGS: "my-bookings",
  CREW: "crew",
  EQUIPMENT: "equipment",
}

/**
 * The rows a month day card reserves above its multi-day bars: the day's blackout chip and its
 * "N bookings require action" alert. A week reserves the union of what its days need, so the
 * bars below stay level across the row — see `buildDayAlertSlots`.
 */
const DAY_ALERT_SLOT = {
  CHIP: "chip",
  ACTION: "action"
}

const DEFAULT_START_HOUR = 0
const DEFAULT_END_HOUR = 23

const WeekDaysLabels = [
  { shortName: "Sun", fullName: "Sunday" },
  { shortName: "Mon", fullName: "Monday" },
  { shortName: "Tue", fullName: "Tuesday" },
  { shortName: "Wed", fullName: "Wednesday" },
  { shortName: "Thu", fullName: "Thursday" },
  { shortName: "Fri", fullName: "Friday" },
  { shortName: "Sat", fullName: "Saturday" }
]

const DEFAULT_RANGE = "month"
const RANGE_OPTIONS = {
  date: "Day",
  week: "Week",
  month: "Month"
}

const TIME_OFF_BE_KEYS = {
  weekDays: "weekdays",
  dateRange: "date_range",
  singleDay: "single_day"
}

const TIME_OFF_WEEKS_COLUMNS = ["Day(s) of the Week", "Time", "Starts on", "Ends on", ""]
const TIME_OFF_DATE_RANGE_COLUMNS = ["Starts on", "Ends on", ""]
const TIME_OFF_SINGLE_DAY_COLUMNS = ["Day Off", "Starts at", "Ends at", ""]

const TIME_OFF_COLUMNS = {
  weekdays: TIME_OFF_WEEKS_COLUMNS,
  date_range: TIME_OFF_DATE_RANGE_COLUMNS,
  single_day: TIME_OFF_SINGLE_DAY_COLUMNS
}

// Single accessor for time-off columns per type
const getTimeOffColumns = (view) => TIME_OFF_COLUMNS[view] || []

/**
 * The bar down the left of a month booking tile, and the "Bookings" swatches in the Legend.
 *
 * The calendar only needs three states, so every unsettled status collapses into one:
 * "paid" is settled, an explicit failure is red, and anything else still owes money.
 */
const BOOKING_PAYMENT_STATES = [
  { key: "paid", labelKey: "calendar.legend.paid", labelDefault: "Paid", color: "var(--color-success)" },
  { key: "balance_due", labelKey: "calendar.legend.balance_due", labelDefault: "Balance due", color: "var(--color-operator-collect)" },
  { key: "failed", labelKey: "calendar.legend.payment_failed", labelDefault: "Payment failed", color: "var(--color-red-text)" }
]

/**
 * `full_paid` is what the guide bookings API actually calls a settled booking — it is the value
 * `displayPaymentStatus` maps to "Paid" and the one the bookings list filters on. `paid` is kept
 * alongside it because parts of the app use that spelling. `partial` is deliberately absent: a
 * part-paid booking still owes a balance.
 */
const PAID_PAYMENT_STATUSES = ["full_paid", "paid", "refunded", "partially_refunded", "partial_refund"]
const FAILED_PAYMENT_STATUSES = ["failed", "payment_failed", "declined"]

/**
 * The day's own shading, and the "Day Status" swatches in the Legend. `none` is an ordinary
 * day, so its swatch is an outline rather than a fill.
 */
const DAY_STATUS_STATES = [
  { key: "none", labelKey: "calendar.legend.day_normal", labelDefault: "Normal", color: null },
  { key: "partial", labelKey: "calendar.legend.day_partial", labelDefault: "Partially affected", color: "var(--color-text-tertiary-light)" },
  { key: "full", labelKey: "calendar.legend.day_full", labelDefault: "Business blackout", color: "var(--color-text-primary)" }
]


export {
  MAX_VISIBLE_EVENTS,
  MAX_VISIBLE_MONTH_EVENTS,
  DAYS_IN_WEEK,
  BOOKING_PAYMENT_STATES,
  PAID_PAYMENT_STATUSES,
  FAILED_PAYMENT_STATUSES,
  DAY_STATUS_STATES,
  DAY_ALERT_SLOT,
  UNASSIGNED_ID,
  CALENDAR_TABS,
  DEFAULT_START_HOUR,
  DEFAULT_END_HOUR,
  WeekDaysLabels,
  DEFAULT_RANGE,
  RANGE_OPTIONS,
  TIME_OFF_WEEKS_COLUMNS,
  TIME_OFF_DATE_RANGE_COLUMNS,
  TIME_OFF_SINGLE_DAY_COLUMNS,
  TIME_OFF_COLUMNS,
  TIME_OFF_BE_KEYS,
  getTimeOffColumns
}
